export default __webpack_public_path__ + "static/media/grasshopper-insect-side-view-shape.dfdc1ddb.svg";